var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCheckPrescription = function SvgCheckPrescription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#check-prescription_svg__clip0_1546_142271)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.833 9.057L5.971 7.195l-.942.943 2.804 2.805 4.472-4.472-.943-.942-3.529 3.528z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 14.667A6.674 6.674 0 011.833 8 6.674 6.674 0 018.5 1.333 6.674 6.674 0 0115.167 8 6.674 6.674 0 018.5 14.667z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "check-prescription_svg__clip0_1546_142271"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCheckPrescription;